import { CUSTOM_ELEMENTS_SCHEMA, Component, Input, inject } from '@angular/core';
import { UserInfo } from '@app-types/user-info';
import { TranslocoModule } from '@ngneat/transloco';
import { SpacerComponent } from 'src/app/common/components/spacer/spacer.component';
import iconLibrary from 'src/app/common/iconLibrary';
import { ApiSignal } from 'src/app/common/util/api-signal';
import { DialogService } from 'src/app/common/util/dialog-service';
import { InfoInputField } from 'src/app/util/user-info-input-fields';

@Component({
  selector: '[wctProfileSection]',
  standalone: true,
  imports: [TranslocoModule, SpacerComponent],
  templateUrl: './profile-section.component.html',
  styleUrl: './profile-section.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProfileSectionComponent {
  @Input({ required: true }) public inputs!: ReadonlyArray<InfoInputField<UserInfo>>;
  @Input({ required: true }) public userInfo!: ApiSignal<UserInfo>;
  @Input({ required: true }) public headlineI18n!: string;

  protected readonly iconLibrary = iconLibrary;

  private readonly dialogService = inject(DialogService);
}
